import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { MatSliderModule } from '@angular/material/slider';

import { ImageSliderComponent } from './image-slider.component';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    TranslateModule,
    FormsModule,
    MatSliderModule,
  ],
  declarations: [ImageSliderComponent],
  exports: [ImageSliderComponent],
  providers: [],
})
export class ImageSliderModule {}
